import subscribe from "./subscribe";
const coupon= {
    async add(newSubscription = false){
        let input = await modal.input(language.coupon_code_text,'text','',language.coupon_code_btn);
        if(newSubscription){
            let data = await API.post("/subscription/checkCoupon", {"code": input});
            if(data.status === 200){
                await modal.alert(data.message);
                $("#subscribe_coupon_nr").val(data.coupon_nr);
                $("#subscribe_add_coupon_btn").html(`<span>Kortingscode : ${data.coupon_nr}</span>`);
                subscribe.fetchPrices();

            } else {
                await modal.alert(data.message);
            }
        } else {
            let data = await API.post("/subscription/redeemCoupon", {"code": input});
            if(data.status === 200){
                await modal.alert(data.message);
                window.location.href = "/subscription";
            } else {
                await modal.alert(data.message);
            }
        }

    }
};

export default coupon;
window.coupon = coupon;